import { getDistance, isPointWithinRadius } from 'geolib';

export const handleGetDistance = (coordinates, viewport) =>
  getDistance(
    { latitude: Number(coordinates.latitude), longitude: Number(coordinates.longitude) },
    { latitude: viewport.latitude, longitude: viewport.longitude }
  );

export const handleSalonsInTwentyKmRadius = (coordinates, viewport) =>
  isPointWithinRadius(
    { latitude: Number(coordinates.latitude), longitude: Number(coordinates.longitude) },
    { latitude: viewport.latitude, longitude: viewport.longitude },
    20000
  );

export const handleSalonsInFiftyKmRadius = (coordinates, viewport) =>
  isPointWithinRadius(
    { latitude: Number(coordinates.latitude), longitude: Number(coordinates.longitude) },
    { latitude: viewport.latitude, longitude: viewport.longitude },
    50000
  );

export const handleSalonsInOneHundredKmRadius = (coordinates, viewport) =>
  isPointWithinRadius(
    { latitude: Number(coordinates.latitude), longitude: Number(coordinates.longitude) },
    { latitude: viewport.latitude, longitude: viewport.longitude },
    100000
  );

export const normalizeEmail = email =>
  typeof email === 'string' ? email.trim().toLowerCase() : '';

export const salonMatchesEmail = (salon, email) => {
  const target = normalizeEmail(email);
  return (
    Boolean(target) &&
    [salon?.salonEmail, salon?.parentEmail].some(e => normalizeEmail(e) === target)
  );
};
